import compositionElement from "./compositionElement.js";
import pageElement from "./pageElement.js";

export default [
    {
        name: "compositionElement",
        value: compositionElement,
    },
    {
        name: "pageElement",
        value: pageElement,
    },
]